import type { CreateTaskResult } from "@/stores/task/types";
import type { TaskType } from "@/types/task";

export function createNewSingleTask() {
  const queryClient = useQueryClient();

  const query = useMutation({
    onSuccess: data => {
      queryClient.invalidateQueries({
        queryKey: [data.scheduleTime ? "scheduled-tasks" : "tasks"],
      });
    },
    mutationFn: async (input: { taskType: TaskType; formData: any }) => {
      const { taskType, formData } = input;
      if (formData.scheduleTime && formData.scheduleTime.type === "date") {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        formData.scheduleTime.timezone = timezone;
      }
      const data = Object.assign({}, formData, { taskType });
      const response = await usePutRequest<CreateTaskResult>("/tasks", data);

      if (response.data) {
        if (response.data.scheduleTime) {
          trackAnalyticsEvent({
            event: "interaction",
            category: "Task",
            action: "schedule:success",
            label: response.data.taskType,
          });
        } else {
          trackAnalyticsEvent({
            event: "interaction",
            category: "Task",
            action: "create:success",
            label: response.data.taskType,
          });
        }
      }

      return response.data || null;
    },
  });

  return query;
}
